import { FrameName } from "../config";
import AbstractSalvageableTileEntity from "./AbstractSalvageableTileEntity";

class HillsCastleRuinsSalvageableTileEntity extends AbstractSalvageableTileEntity {
	public static readonly frameName = FrameName.HILLS_CASTLE_RUINS;
}

export default HillsCastleRuinsSalvageableTileEntity;
